import { getAppConfig } from "@core/config";
import { Product } from "@core/types";

type ProductWithUnit = Pick<Product, "portionUnit"> & { unitName?: string };

interface GetProductQuantityStepParams {
  product: ProductWithUnit;
}

interface NormalizeProductQuantityParams {
  quantity: number;
  product: ProductWithUnit;
}

export const isWeightBasedProduct = (product: ProductWithUnit) =>
  product.portionUnit === "KGM" || product.unitName === "KGM";

export const getProductQuantityStep = ({ product }: GetProductQuantityStepParams) => {
  const { isWeightProductQuantityStepEnabled, stepForWeightProductQuantity } = getAppConfig();
  return isWeightProductQuantityStepEnabled && isWeightBasedProduct(product) ? stepForWeightProductQuantity : 1;
};

export const normalizeProductQuantity = ({
  quantity,
  product,
}: NormalizeProductQuantityParams) => {
  const { isWeightProductQuantityStepEnabled } = getAppConfig();
  const isWeightQuantity = isWeightProductQuantityStepEnabled && isWeightBasedProduct(product);

  return isWeightQuantity ? Math.round(quantity * 1000) / 1000 : Math.round(quantity);
};
